const siteName = 'Lessonize';

export default function getPageTitle(docTitle) {
  if (docTitle) {
    return docTitle + ` - Lessonize`;
  }

  return siteName;
}
